export default __webpack_public_path__ + "static/media/hamzaimg.a338f6c8.png";